<script setup>
defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});
</script>
<template>
  <section
    v-if="data?.content"
    :id="data.id"
    class="section"
    :class="[
      data?.background_color && data.template !== 'article'
        ? `bg-${data.background_color}`
        : '',
      data?.spacing?.top ? `section--top-${data.spacing.top}` : '',
      data?.spacing?.bottom ? `section--bottom-${data.spacing.bottom}` : '',
    ]"
    data-aos="fade-up"
    data-aos-easing="ease-out-cubic"
  >
    <div :class="['container', `container--${data?.template}`]">
      <div
        :class="[
          'article__text body-3-2-regular',
          data.background_color === 'black' && data.template !== 'article'
            ? 'white'
            : 'black',
        ]"
        data-aos="fade-up"
        data-aos-easing="ease-out-cubic"
        v-html="data.content"
      ></div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.article {
  &__text {
    &:deep(p:last-child) {
      margin-bottom: 0;
    }
    &:deep(img),
    &:deep(video) {
      border-radius: 8px;
      height: auto;
      width: 100%;
      @include media-breakpoint-up(xl) {
        @include responsive-spacing(border-radius, 8);
      }
    }
    &:deep(ul) {
      list-style: none;
      padding-left: 24px;
      @include media-breakpoint-up(xl) {
        @include responsive-spacing(padding-left, 24);
      }
    }
    &:deep(ul li) {
      margin-top: 16px;
      position: relative;
      &:before {
        background: url('/images/style/check.svg') no-repeat 0 0;
        background-size: contain;
        content: '';
        height: 16px;
        left: -24px;
        top: 5px;
        position: absolute;
        width: 16px;
        z-index: 0;
      }
      @include media-breakpoint-up(xl) {
        @include responsive-spacing(margin-top, 16);
        &:before {
          @include responsive-spacing(left, -24);
          @include responsive-spacing(top, 5);
          @include responsive-spacing(height, 16);
          @include responsive-spacing(width, 16);
        }
      }
    }
    &:deep(ol) {
      @include body-1-bold;
      padding-left: 0;
    }
    &:deep(ol li) {
      margin-top: 16px;
      @include media-breakpoint-up(xl) {
        @include responsive-spacing(margin-top, 16);
      }
    }
  }
}
</style>
